var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.31 0.31 24.5 24.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-close-2_svg__Icon_-_Close",
    "data-name": "Icon - Close",
    transform: "translate(-332.189 -58.439)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-close-2_svg__Line_637",
    "data-name": "Line 637",
    transform: "rotate(90 148.375 207.875)",
    d: "M0 0l23 23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-close-2_svg__Line_638",
    "data-name": "Line 638",
    transform: "translate(333.25 59.5)",
    d: "M0 0l23 23"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAuMzEgMC4zMSAyNC41IDI0LjUiPiAgPGcgaWQ9Ikljb25fLV9DbG9zZSIgZGF0YS1uYW1lPSJJY29uIC0gQ2xvc2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMzIuMTg5IC01OC40MzkpIj4gICAgPGxpbmUgaWQ9IkxpbmVfNjM3IiBkYXRhLW5hbWU9IkxpbmUgNjM3IiB4Mj0iMjMiIHkyPSIyMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzU2LjI1IDU5LjUpIHJvdGF0ZSg5MCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48L2xpbmU+ICAgIDxsaW5lIGlkPSJMaW5lXzYzOCIgZGF0YS1uYW1lPSJMaW5lIDYzOCIgeDI9IjIzIiB5Mj0iMjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMy4yNSA1OS41KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiPjwvbGluZT4gIDwvZz48L3N2Zz4K";
export { SvgIconClose2 as ReactComponent };